import Link from 'app/shared/components/Link/Link';
import styled from 'styled-components';

export const LinkSt = styled(Link).attrs({
  alwaysFullWidth: true,
  isBlock: true,
})`
  margin: 2rem 0;
`;
